import { TooltipPosition, TextPosition, TooltipDataItemValueType } from './constants';

export { SizeUnits, FontWeightOptions, BorderStyleOptions, BorderWidthUnits } from '@goodt-wcore/panels';


export const TooltipPositionOptions = [
    { value: TooltipPosition.TOP, label: 'Сверху (центр)' },
    { value: TooltipPosition.TOP_START, label: 'Сверху (начало)' },
    { value: TooltipPosition.TOP_END, label: 'Сверху (конец)' },
    { value: TooltipPosition.LEFT, label: 'Слева (центр)' },
    { value: TooltipPosition.LEFT_START, label: 'Слева (начало)' },
    { value: TooltipPosition.LEFT_END, label: 'Слева (конец)' },
    { value: TooltipPosition.RIGHT, label: 'Справа (центр)' },
    { value: TooltipPosition.RIGHT_START, label: 'Справа (начало)' },
    { value: TooltipPosition.RIGHT_END, label: 'Справа (конец)' },
    { value: TooltipPosition.BOTTOM, label: 'Снизу (центр)' },
    { value: TooltipPosition.BOTTOM_START, label: 'Снизу (начало)' },
    { value: TooltipPosition.BOTTOM_END, label: 'Снизу (конец)' }
];

export const TextAlignOptions = [
    { value: TextPosition.LEFT, label: 'Слева' },
    { value: TextPosition.CENTER, label: 'По центру' },
    { value: TextPosition.RIGHT, label: 'Справа' }
];

export const TooltipDataItemValueTypeOptions = [
    {value: TooltipDataItemValueType.STRING, label: 'Строка'},
    {value: TooltipDataItemValueType.NUMBER, label: 'Число'},
    {value: TooltipDataItemValueType.DATE, label: 'Дата'},
];

export const TooltipPanelGroups = [
    { name: 'Внешний вид', slot: 'settings' },
    { name: 'Данные', slot: 'data' },
    { name: 'Переменные', slot: 'vars' },
];

export const PrfPsfGroups = [
    { name: 'Префикс', slot: 'prf', option: 'prefix' },
    { name: 'Постфикс', slot: 'psf', option: 'postfix' }
];
